(function($){
    $.fn.validationEngineLanguage = function(){
    };
    $.validationEngineLanguage = {
        newLang: function(){
            $.validationEngineLanguage.allRules = {
                "required": { // Add your regex rules here, you can take telephone as an example
                    "regex": "none",
                    "alertText": "* Ezt a mezőt ki kell tölteni",
                    "alertTextCheckboxMultiple": "* Kérlek válassz egy opciót",
                    "alertTextCheckboxe": "* Ez az opció be kell legyen jelölve",
                    "alertTextDateRange": "* Mindkét dátum mezőt ki kell tölteni"
                },
                "requiredInFunction": { 
                    "func": function(field, rules, i, options){
                        return (field.val() == "test") ? true : false;
                    },
                    "alertText": "* Field must equal test"
                },
                "dateRange": {
                    "regex": "none",
                    "alertText": "* Érvénytelen ",
                    "alertText2": "Dátum tartomány"
                },
                "dateTimeRange": {
                    "regex": "none",
                    "alertText": "* Érvénytelen ",
                    "alertText2": "Dátum-idő tartomány"
                },
                "minSize": {
                    "regex": "none",
                    "alertText": "* Minimum ",
                    "alertText2": " karakter kell legyen"
                },
                "maxSize": {
                    "regex": "none",
                    "alertText": "* Maximum ",
                    "alertText2": " karakter lehet"
                },
				"groupRequired": {
                    "regex": "none",
                    "alertText": "* Az alábbi mezők valamelyikét ki kell tölteni"
                },
                "min": {
                    "regex": "none",
                    "alertText": "* A minimum érték "
                },
                "max": {
                    "regex": "none",
                    "alertText": "* A maximum érték "
                },
                "past": {
                    "regex": "none",
                    "alertText": "* Dátum ez előtt "
                },
                "future": {
                    "regex": "none",
                    "alertText": "* Dátum ez után "
                },	
                "maxCheckbox": {
                    "regex": "none",
                    "alertText": "* Maximum ",
                    "alertText2": " opció lehet bejelölve"
                },
                "minCheckbox": {
                    "regex": "none",
                    "alertText": "* Kérjük válassz ",
                    "alertText2": " opciót"
                },
                "equals": {
                    "regex": "none",
                    "alertText": "* A két jelszó nem egyezik"
                },
                "creditCard": {
                    "regex": "none",
                    "alertText": "* Érvénytelen kártyaszám"
                },
                "phone": {
                    // credit: jquery.h5validate.js / orefalo
                   "regex": /^([\+][0-9]{1,3}([ \.\-])?)?([\(][0-9]{1,6}[\)])?([0-9 \.\-]{1,32})(([A-Za-z \:]{1,11})?[0-9]{1,4}?)$/,
                    "alertText": "* Érvénytelen telefonszám"
                },
                "email": {
                    // HTML5 compatible email regex ( http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#    e-mail-state-%28type=email%29 )
                    "regex": /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    "alertText": "* Hibás E-mail cím"
                },
                "integer": {
                    "regex": /^[\-\+]?\d+$/,
                    "alertText": "* Nem érvényes (egész) szám"
                },
                "number": {
                    // Number, including positive, negative, and floating decimal. credit: orefalo
                    "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
                    "alertText": "* Érvénytelen szám"
                },
                "date": {
                    "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/,
                    "alertText": "* Érvénytelen dátum, ÉÉÉÉ-HH-NN formátumban kell megadni"
                },
                "ipv4": {
                    "regex": /^((([01]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))[.]){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))$/,
                    "alertText": "* Érvénytelen IP cím"
                },
                "url": {
                    "regex": /^(https?|www)|:|\/|\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
                    "alertText": "* Érvénytelen URL"
                },
				"VatNumber": {
                    "regex": /^([0-9]{8})[-]([0-9]{1}[-]([0-9]{2}))+$/,
                    "alertText": "* Hibás formátumú adószám - a helyes formátum: 12345678-1-12"
                },
				// "bankNumber": {
                    // "regex": /^([0-9]{8})(([-]?[0-9]{8}){1,2})+$/,
                    // "alertText": "* Hibás formátumú bankszámlaszám"
                // },
				"bankNumber": {
                    "regex": /^([0-9\ \/\-])+$/,
                    "alertText": "* Hibás formátumú bankszámlaszám"
                },
                "onlyNumber": {
                    "regex": /^[0-9]+$/,
                    "alertText": "* Csak számot írj"
                },
                "onlyNumberSp": {
                    "regex": /^[0-9\ ]+$/,
                    "alertText": "* Csak számot írj"
                },
                "onlyLetterSp": {
                    "regex": /^[A-Za-záíűőúóüöéÁÍŰŐÚÓÜÖÉ\ \' \/ \. \-]+$/,
                    "alertText": "* Csak betűket írj"
                },
                "onlyLetterNumber": {
                    "regex": /^[0-9a-zA-ZáíűőúóüöéÁÍŰŐÚÓÜÖÉ]+$/,
                    "alertText": "* Spéci karakterek nem engedélyezettek"
                },
				  "letterNumberSp": {
                    "regex": /^[0-9a-zA-ZáíűőúóüöéÁÍŰŐÚÓÜÖÉ:\&?\_\-\=\ \'\/\.\, \r\n]+$/,
                    "alertText": "* Speciális karakterek nem engedélyezettek"
                },
				"specChars": {
                    "regex": /^[a-zA-Z0-9áíűőúóüöéÁÍŰŐÚÓÜÖÉ:.?!#$%&'*\ \+\-\/\=\.\,\r\n]+$/,
                    "alertText": "* Speciális karakterek nem engedélyezettek"
                },
                // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
                "ajaxUserCall": {
                    "url": "ajaxValidateFieldUser",
                    // you may want to pass extra data on the ajax call
                    "extraData": "name=eric",
                    "alertText": "* This user is already taken",
                    "alertTextLoad": "* Validating, please wait"
                },
				"ajaxUserCallPhp": {
                    "url": "php/ajax/ajaxValidateUser.php",
                    // you may want to pass extra data on the ajax call
                    // "extraData": "name=eric",
                    // if you provide an "alertTextOk", it will show as a green prompt when the field validates
                    "alertText": "* Ez a felhasználónév már folglalt:(",
                    "alertTextLoad": "* Felhasználónév ellenörzés..."
                },
                "ajaxNameCall": {
                    // remote json service location
                    "url": "ajaxValidateFieldName",
                    // error
                    "alertText": "* This name is already taken",
                    // if you provide an "alertTextOk", it will show as a green prompt when the field validates
                    "alertTextOk": "* This name is available",
                    // speaks by itself
                    "alertTextLoad": "* Validating, please wait"
                },
				 "ajaxEmailCallPhp": {
	                    // remote json service location
	                    "url": "php/ajax/ajaxValidateEmail.php",
	                    // error
	                    "alertText": "* Ez az email cím már használatban van. <a href=\"elfelejtett-jelszo\">Új jelszót kérek erre az email címre>></a>",
	                    // speaks by itself
	                    "alertTextLoad": "* Email cím ellenőrzése"
	             },
				  "ajaxOwnEmailCallPhp": {
	                    // remote json service location
	                    "url": "php/ajax/ajaxValidateOwnEmail.php",
						 "extraDataDynamic": ['#user_id'],
	                    // error
	                    "alertText": "* Ez az email cím már használatban van.",
	                    // speaks by itself
	                    "alertTextLoad": "* Email cím ellenőrzése..."
	             },

				 "ajaxEuvatCallPhp": {
	                    // remote json service location
	                    "url": "php/ajax/ajax-validate-euvat.php",
	                    // error
	                    "alertText": "* Ez az eu-s adószám nem létezik.",
	                    // speaks by itself
	                    "alertTextLoad": "* Ellenőrzöm"
	                },
                "validate2fields": {
                    "alertText": "* Please input HELLO"
                },
	            //tls warning:homegrown not fielded 
                "dateFormat":{
                    "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/,
                    "alertText": "* Invalid Date"
                },
                //tls warning:homegrown not fielded 
				"dateTimeFormat": {
	                "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/,
                    "alertText": "* Invalid Date or Date Format",
                    "alertText2": "Expected Format: ",
                    "alertText3": "mm/dd/yyyy hh:mm:ss AM|PM or ", 
                    "alertText4": "yyyy-mm-dd hh:mm:ss AM|PM"
	            }
            };
            
        }
    };

    $.validationEngineLanguage.newLang();
    
})(jQuery);
